/**
 * Update Modal Component
 *
 * Shows a centered modal overlay when the app version is unsupported.
 * The user must click "Update Now" which triggers forceUpdate()
 * (logout + IDB delete + redirect to /login).
 *
 * Uses the new CDN-based ReleaseConfigService (3-state model).
 */

import { CommonModule } from '@angular/common';
import { Component, computed, Signal, effect } from '@angular/core';
import { SettingsService } from '@app/_services/settings.service';
import { ReleaseConfigService } from '@app/_services/release-config.service';
import { log } from '@app/_services/logger';
import { BRAND_CONFIG } from '@app/_generated/brand.gen';

@Component({
    selector: 'app-update-modal',
    imports: [CommonModule],
    templateUrl: './update-modal.component.html',
    styleUrl: './update-modal.component.scss'
})
export class UpdateModalComponent {

  readonly BRAND_CONFIG = BRAND_CONFIG;

  /** Whether to show the modal (only for unsupported status) */
  showModal: Signal<boolean> = computed(() => {
    return this.releaseConfigService.versionStatus() === 'unsupported';
  });

  /** Track previous modal state to log only on changes */
  private previousShowModal = false;

  constructor(
    public ss: SettingsService,
    private releaseConfigService: ReleaseConfigService,
  ) {
    // Log warning when update modal is shown
    effect(() => {
      const isShowing = this.showModal();
      if (isShowing && !this.previousShowModal) {
        log.warn('UpdateModalComponent', 'UNSUPPORTED VERSION — update modal displayed', {
          versionStatus: this.releaseConfigService.versionStatus(),
        });
      }
      this.previousShowModal = isShowing;
    });
  }

  /** User clicked "Update Now" — force update (logout + IDB delete + redirect) */
  onForceUpdate(): void {
    this.releaseConfigService.forceUpdate();
  }
}
